module.exports = __webpack_public_path__ + "img/no-data.2f4e66d7.png";